import React, {useEffect, useState} from 'react'
import FieldTags from "../../tags"
import FieldMultiselect_FormComponent from "../../../multiselect/components/form/form-component"
import FieldDropdownLazyLoading_FormValueLoading from "../../../dropdown-lazy-loading/render/form/value-loading"

type Props = {
    field               : FieldTags
    value               : any
    disabled?           : boolean

    onChange?           : callback
    onImmediateChange?  : callback

    className?          : string
}

export default function FieldTags_FormView(props: Props) {

    const [isLoaded, setIsLoaded] = useState(props.field.isLoaded)

    useEffect(() => {
        if (isLoaded) {
            return
        }

        let isMounted = true

        props.field.loadOptions(() => {
            if (isMounted) {
                setIsLoaded(true)
            }
        })

        return () => {
            isMounted = false
        }
    }, [isLoaded])

    if (!isLoaded) {
        return (
            <FieldDropdownLazyLoading_FormValueLoading
                className   = {props.className}
                field       = {props.field}
                disabled    = {props.disabled}
            />
        )
    }

    return (
        <FieldMultiselect_FormComponent
            field               = {props.field}
            className           = {props.className}
            value               = {props.value}
            disabled            = {props.disabled}
            onChange            = {props.onChange}
            onImmediateChange   = {props.onImmediateChange}
        />
    )
}
